import { BaseService } from "./BaseService";
import { SnackBarModule } from "../modules/SnackBarModule";

export const ExcluirFeriasService = {
    async excluirFerias(id) 
    {
        const response = await BaseService.fetchResponseFromAPIPost(
            `ferias/${id}/delete`);
        if (response.error) {
            SnackBarModule(response.message, "error");
            return false;
        }
        SnackBarModule("Deletado com sucesso", "success");
        return true;
    },

    async excluirFeriasCivil(id) 
    {
        const response = await BaseService.fetchResponseFromAPIPost(
            `civil/ferias/${id}/delete`);
        if (response.error) {
            SnackBarModule(response.message, "error");
            return false;
        }
        SnackBarModule("Deletado com sucesso", "success");
        return true;
    },

    async pegarUsuariosAbono(postData) 
    {
        const response = await BaseService.fetchResponseFromAPIPost(
            `ferias/abono`,
            postData);
        if (response.error) {
            SnackBarModule(response.message, "error");
            return false;
        }
        return response.message;
    },

    async excluirFeriasParametizar(postData) 
    {
        const response = await BaseService.fetchResponseFromAPIPost(
            `ferias/deleteparam`,
            postData);
        if (response.error) {
            SnackBarModule(response.message, "error");
            return false;
        }
        SnackBarModule("Efetuado com Sucesso", "success");
        return true;
    },
}

